// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginForm_root__1xc4y"};